if (`${process.env.REACT_APP_DEVELOPMENT_ENV}` === "staging") {
  window.livasaServiceUrl = "https://iamstaging.gbrservice.com/";
  window.livasa_ContentUrl = "https://proxystaging.gbrservice.com/";
  window.otpLead = "https://registrystaging.gbrservice.com/";
  window.networkid = process.env.REACT_APP_CONSUMER_ADMIN_STAGING;
  window.clientId = process.env.REACT_APP_CLIENT_ID_STAGING;
  window.clientSecret = process.env.REACT_APP_CLIENT_SECRET_STAGING;
} else if (`${process.env.REACT_APP_DEVELOPMENT_ENV}` === "production") {
  window.livasaServiceUrl = "https://iam.gbrservice.com/";
  window.livasa_ContentUrl = "https://content.gbrservice.com/";
  window.networkid = process.env.REACT_APP_CONSUMER_ADMIN_PRODUCTION;
  window.otpLead = "https://registrygcp.gbrservice.com/";
  window.clientId = process.env.REACT_APP_CLIENT_ID_PRODUCTION;
  window.clientSecret = process.env.REACT_APP_CLIENT_SECRET_PRODUCTION;
}

let subcatogory = "Livasa-Natural-Honey";
let user = process.env.REACT_APP_ASSET_DEVELOPER_STAGING;
window.livasaConfig = {
  // https://registrystaging.gbrservice.com/OTPAuthenticationService/consumer2/otp/register/otpauth/5BJEZdvqabHetnDYh6ZcUUB6EmOr01xY
  // getOtp: window.otpLead + "OTPAuthenticationService/otp/lead",
  getOtp: window.otpLead + "OTPAuthenticationService/",
  validateOtp: window.otpLead + "OTPAuthenticationService/validateOtp/",
  resendOTP: window.otpLead + "OTPAuthenticationService/resendOtp/",

  subcatogory: subcatogory,
  user: user,
  networkid: window.networkid,
  clientId: window.clientId,
  clientSecret: window.clientSecret,
  token: window.livasaServiceUrl + "AuthBackEndGw/token/",
  getCategories: window.livasa_ContentUrl + "ContentGw/getCategories/",
  modelBasedOnCategory:
    window.livasa_ContentUrl + "AgriProductProxy/getproductlist/",
  productLikeCount:
    window.livasa_ContentUrl + "AgriProductProxy/updateLikeCount/",
  // getSubCategories:
  //   window.livasa_ContentUrl + "ContentGw/getAllContentSubCategories/",

  getSubCategories: window.livasa_ContentUrl + "ContentGw/",
  getAllProducts: window.livasa_ContentUrl + "AgriProductProxy/product/",

  getAllusersofUserType:
    window.livasaServiceUrl + "OpUserService/getAllConsumerUsers/",
  getAllProductsBasedonParentId:
    window.livasa_ContentUrl + "AgriProductProxy/allproducts/",
  registerUser: window.otpLead + "AgriBusinessRegistryService/register/",
};
